import { observer } from 'mobx-react-lite';
import { PropsWithChildren } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { Loader } from '@/components/Loader';
import { routes } from '@/constants/routes';
import { store } from '@/store';

export const LoaderProvider = observer<PropsWithChildren>(({ children }) => {
  if (!store.app.isReady && !store.errorHandler.state.error) return <Loader />;
  if (store.errorHandler.state.error) return <Navigate to={routes.error} />;

  return (
    <>
      <Outlet />
      {children}
    </>
  );
});
